import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class TruncateBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            overflowing: false,
        };
    }
    componentDidMount() {
        if( this.isOverflowing() ) {
            this.setState( { overflowing: true } );
        }
    }
    isOverflowing = () => {
        if( !this._el ) {
            return false;
        }
        return this._el.clientHeight < this._el.scrollHeight;
    }


    render() {
        const { children, overflowMessage } = this.props;
        const { overflowing } = this.state;
        const className = `${ style.truncateBlock } ${ this.props.className }`.trim();

        return (
            <div className={ className } style={ this.props.style } data-overflow={ overflowing }>
                <div className={ style.content } ref={ ( el ) => { this._el = el; } }>
                    { children }
                </div>
                { overflowing &&
                    <div className={ style.overflowIndicator }>
                        <div className='overflow-gradient' />
                        <div className={ style.overflowMessage }>
                            { overflowMessage }
                        </div>
                    </div>
                }
            </div>
        );
    }
}
TruncateBlock.propTypes = {
    className: PropTypes.string,
    overflowMessage: PropTypes.node,
};
TruncateBlock.defaultProps = {
    className: '',
    overflowMessage: <span><Icon source='fontAwesome' icon='fas/faCaretRight'/>Learn More</span>,
};

const mapStateToProps = ( state ) => {
    return {
        screenSize: state.screenSize.width,
    };
};

export default connect( mapStateToProps )( TruncateBlock );
